// extracted by mini-css-extract-plugin
export default {"container":"style_container__o1vHI","animation":"style_animation__z0b3U","success":"style_success__HgXD0","text":"style_text__eaEj2"};